import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: #ffffff;

  position: relative;
`;

export const WrapperFullScreen = styled(Wrapper)`
  min-height: 100%;

  padding: 0 2.5rem;

  overflow-y: auto;

  .MuiTableCell-root {
    font-size: 2.5rem;
  }

  .MuiFormControl-root {
    margin-top: 0.6rem;
  }
`;

export const Header = styled.header`
  margin-bottom: 2rem;
  width: 100%;

  display: flex;
  justify-content: flex-end;
`;

export const Container = styled(Form)`
  flex: 1;
  width: 100%;

  display: flex;
  flex-direction: column;

  .MuiFilledInput-inputMarginDense {
    padding-top: 6px;
  }

  .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel) {
    margin-top: 3px;
  }

  .MuiFilledInput-root,
  .MuiFilledInput-root:hover {
    background-color: transparent !important;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: 2rem;

  position: absolute;

  top: -1.8rem;
  right: 15rem;

  .inputPerPage {
    max-width: 7rem;

    margin-left: 1rem;
    margin-right: 2rem;
  }

  input {
    text-align: center;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-left: 2rem;
`;
